import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {}

const ContractData = ({ children }: React.PropsWithChildren<Props>) => {
  return (
    <Box
      padding="s24"
      border={{
        all: {
          width: 's2',
          color: 'grey400',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      height="full"
    >
      {children}
    </Box>
  )
}

export default observer(ContractData)
